export default {_name:'attachment.item.text',module:'Field',view:'Element/Attachment/Item/Text',options:{key:'text',config:'ui/_shared/file'}}